import React from 'react';
import { Button } from 'antd';
import NetworkIcon from 'components/NetworkIcon';
import { snackbar } from 'components/notifications/notifications';
import useMetaLogin from 'modules/network-accounts/hooks/useMetaLogin';
import { useConnectMetaMutation } from 'modules/apps/apps/MetaApp/api/meta.api';
import useAccountConnectionFlow from 'components/AccountConnectionFlow/AccountConnectionFlow.provider';

const ConnectMetaStep = () => {
  const flow = useAccountConnectionFlow();
  const { loading: authLoading, openLogin: openMetaLoginPopup } = useMetaLogin();
  const [connectMetaAccountsRequest, { isLoading: isConnectLoading }] = useConnectMetaMutation();

  const connectMeta = async () => {
    const sdkResponse = await snackbar.promise(() => openMetaLoginPopup(), {
      loadingMessage: 'Waiting for Meta Login...',
      successMessage: 'Successfully Logged in',
      errorMessage: 'Error while login to Meta',
    });

    if (!sdkResponse.success) {
      throw new Error('Error while login to Meta');
    }

    /**
     * @var {ConnectMetaResponse} sdkResponse
     */
    const apiResponse = await snackbar.promise(
      () => connectMetaAccountsRequest(sdkResponse).unwrap(),
      {
        loadingMessage: 'Connecting to MyDataNinja...',
        successMessage: 'Successfully Connected',
        errorMessage: 'Error while connecting Meta to MyDataNinja',
      }
    );

    if (!apiResponse.connection_batch) {
      throw new Error('Error while connecting accounts to mydataninja');
    }

    flow.setConnectionBatch(apiResponse.connection_batch);
    flow.changeStep('choose_accounts');
  };

  const isLoading = isConnectLoading || authLoading;

  return (
    <div className='w-full flex-center pt-8'>
      <Button
        onClick={connectMeta}
        type='dashed'
        size='large'
        loading={isLoading}
        icon={<NetworkIcon network='facebook' />}
      >
        {isLoading
          ? 'Please Finish connection or refresh'
          : 'Click Here To Connect Your Meta Ad Accounts'}
      </Button>
    </div>
  );
};

export default ConnectMetaStep;
